import { format, parseISO } from "date-fns";
import { Button } from "../ui/button";
import { Label } from "../ui/label";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { Calendar } from "../ui/calendar";
import { cn } from "../../lib/utils";
import { Calendar as CalendarIcon } from "lucide-react";

/**
 * Date field backed by a shadcn Popover + react-day-picker Calendar.
 * `blockedDates` (a Set of "yyyy-MM-dd" strings) are struck through and disabled.
 */
export function DateField({ label, value, onChange, minDate, blockedDates, testid }) {
  const parsed = value ? parseISO(value) : undefined;
  const isBlocked = (d) => !!blockedDates && blockedDates.has(format(d, "yyyy-MM-dd"));
  const isDisabled = (d) => {
    if (d < new Date(new Date().toDateString())) return true;
    if (minDate && d < parseISO(minDate)) return true;
    if (isBlocked(d)) return true;
    return false;
  };
  return (
    <div>
      <Label>{label}</Label>
      <Popover>
        <PopoverTrigger asChild>
          <Button type="button" variant="outline" data-testid={testid}
            className={cn("w-full justify-start font-normal", !value && "text-muted-foreground")}>
            <CalendarIcon size={14} className="mr-2 shrink-0" />
            {value ? format(parsed, "d MMM yyyy") : "Pick a date"}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start">
          <Calendar
            mode="single"
            selected={parsed}
            onSelect={(d) => d && onChange(format(d, "yyyy-MM-dd"))}
            disabled={isDisabled}
            modifiers={{ booked: isBlocked }}
            modifiersClassNames={{ booked: "line-through text-destructive/70 bg-destructive/10" }}
            initialFocus
          />
        </PopoverContent>
      </Popover>
    </div>
  );
}
